import React, {Component} from 'react';
import {connect} from 'react-redux';
import Login from './login';
import * as actions from '../../actions';

class LoginHOC extends Component {
  render(){
    return (
      <Login
        {...this.props}
      />
    )
  }
}

const mapStateToProps = (state) => {
  return {
    loggingIn: state.loggedInPerson.get('loggingIn'),
    loggingInResponseMessage: state.loggedInPerson.get('loggingInResponseMessage'),
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    login: (payload) => {
      dispatch(actions.login(payload))
    },
    changeUserStoreSettings: (payload) => {
      dispatch(actions.changeUserStoreSettings(payload))
    }
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(LoginHOC);



// WEBPACK FOOTER //
// ./src/components/login/loginHOC.js